import React, { CSSProperties, FC, ReactNode } from 'react';
import { Button, IconButton } from 'snacks-design-system';
import styles from './PIEButton.module.scss';

/* https://snacks.takeaway.com/portal/components/button/usage/ */
/* https://snacks.takeaway.com/portal/components/icon-button/usage/ */
interface IPIEButton {
  text: string;
  onClick: () => void;
  className?: CSSProperties | string;
  isPromising?: boolean;
  size: 'xsmall' | 'small' | 'medium' | 'large';
  mode:
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'ghost'
    | 'inverse'
    | 'ghost-inverse'
    | 'destructive'
    | 'destructive-ghost'
    | 'facebook'
    | 'facebook-inverse'
    | 'google'
    | 'google-inverse'
    | 'apple'
    | 'apple-inverse'
    | 'microsoft'
    | 'microsoft-inverse';
  borderRadiusPosition?: 'all' | 'right' | 'left' /* default all */;
  disabled?: boolean;
  wrapText?: boolean;
  autoWidth?: boolean;
  type: 'button' | 'submit' | 'reset' | 'icon';
  icon?: ReactNode;
  id?: string;
  invert?: string;
  qaSelector?: string;
}

export const PIEButton: FC<IPIEButton> = ({
  text,
  onClick,
  className,
  isPromising,
  borderRadiusPosition,
  disabled,
  wrapText,
  autoWidth,
  type,
  size,
  mode,
  icon,
  id,
  qaSelector,
  invert,
}) => {
  const handleButtonOnClick = () => {
    return onClick();
  };

  return (
    <div id={id}>
      {type === 'icon' ? (
        <IconButton
          onClick={handleButtonOnClick}
          className={className}
          isLoading={isPromising}
          icon={icon}
          size={size}
          disabled={disabled}
          mode={mode}
        >
          {text}
        </IconButton>
      ) : (
        <Button
          qaSelector={qaSelector}
          className={className}
          isLoading={isPromising}
          onClick={handleButtonOnClick}
          size={size}
          disabled={disabled}
          mode={mode}
          type={type}
          borderRadiusPosition={borderRadiusPosition}
          modWrap={wrapText}
          modFluid={autoWidth}
          modA11Y={!!invert}
        >
          <div className={styles.button_icon}>
            {icon ? icon : null} {text}
          </div>
        </Button>
      )}
    </div>
  );
};

export default PIEButton;
